// 使用环境变量配置API地址
// 开发环境：.env.development 中定义 VUE_APP_BASE_API=/api
// 生产环境：.env.production 中定义 VUE_APP_BASE_API=https://4ss.gtdreamlife.com:13015
const config = {
    baseURL: process.env.VUE_APP_BASE_API,
    h5BaseURL: process.env.VUE_APP_H5_BASE_URL,
};
export default config;
